import React from "react";
import ActionsComponent from "../../ActivationCode/tableComponents/actionsComponent";
import {ADMIN} from "../../../constants/roles";

const SignatureImg = ({value}) => <img src={value} alt="sign" className="table-signature"/>

export const cliniciansTableHeader = [
    {label: "First name", sortOption: false, classname: "font-size-13 table-caption-label"},
    {label: "Last name", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "Email address", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "GMC", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {label: "Signature", sortOption: false, classname: "font-size-13 table-caption-label disable-word-wrap"},
    {
        label: "Action",
        sortOption: false,
        classname: "font-size-13 table-caption-label disable-word-wrap action-table-cell"
    },
];

export const cliniciansTableStructure = [
    {
        name: "firstName",
        classname: "font-size-14 pt-20px pb-20px border-bottom fullname-table-cell",
        keyProp: "firstName"
    },
    {name: "lastName", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "lastName"},
    {name: "email", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "email"},
    {name: "gmc", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "doctor.gmc"},
    {
        name: "signature",
        classname: "font-size-13 pt-20px pb-20px border-bottom",
        keyProp: "doctor.link",
        Component: SignatureImg
    }, //todo: img component
    // { name: "actions", classname: "font-size-13 pt-20px pb-20px border-bottom", keyProp: "id", Component: (({value}) => value) },
]

/**
 * superAdmin only: whether this Doctor is exempt from "Own patients only" - sees every doctor's
 * patients in the default lists while that switch is on. For Doctors who work across every doctor's
 * list (ID checks, cover).
 *
 * The box's words never change with the box: "Always sees all patients" is what TICKING means. Words
 * that followed the state ("Own patients" unticked, "All patients" ticked) read as the opposite.
 *
 * Admins (role 4) and super admins always see every patient - the server exempts them by role - so
 * their rows get no checkbox. An Admin row is known by its role, whatever else it carries. The API
 * reports hasFullPatientAccess for Doctors (role 1) only, so any other row without it is a super admin.
 */
export const FullPatientAccessToggle = ({ clinician, onToggle }) => {
    if (clinician.role === ADMIN) {
        return <span className="text-muted" data-testid={`full-access-${clinician.id}-fixed`}>All patients (admin)</span>;
    }
    if (typeof clinician.hasFullPatientAccess !== "boolean") {
        return <span className="text-muted" data-testid={`full-access-${clinician.id}-fixed`}>All patients (super admin)</span>;
    }

    return (
        <label className="d-flex align-items-center mb-0 cursor-pointer">
            <input
                type="checkbox"
                className="mr-2"
                data-testid={`full-access-${clinician.id}`}
                checked={clinician.hasFullPatientAccess}
                onChange={event => onToggle(clinician, event.target.checked)}
            />
            <span>Always sees all patients</span>
        </label>
    );
};

export const fullPatientAccessHeader = {
    label: "Exempt from 'Own patients only'",
    sortOption: false,
    classname: "font-size-13 table-caption-label disable-word-wrap",
};

export const cliniciansStructureWithActions = (handleEdit, onToggleFullAccess) => {
    return [
        ...cliniciansTableStructure,
        ...(onToggleFullAccess ? [{
            name: "fullPatientAccess",
            classname: "font-size-13 pt-20px pb-20px border-bottom",
            Component: (({value}) => <FullPatientAccessToggle clinician={value} onToggle={onToggleFullAccess}/>)
        }] : []),
        {
            name: "actions",
            classname: "font-size-13 pt-20px pb-20px pr-2 pl-3 border-bottom",
            Component: (({value}) => <ActionsComponent item={value} handleEdit={handleEdit}/>)
        },
    ]
}